"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";

/**
 * When the user is signed in and has no timezone in Clerk metadata,
 * sets it from the system timezone (Intl API) via the API.
 */
export function useSyncSystemTimezone() {
  const { user, isLoaded } = useUser();
  const didSyncRef = useRef(false);

  useEffect(() => {
    if (!isLoaded || !user?.id || didSyncRef.current) return;

    const existing = user.publicMetadata?.timezone;
    if (existing && typeof existing === "string" && existing.trim() !== "") {
      return;
    }

    const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!systemTz) return;

    didSyncRef.current = true;
    fetch("/api/user/timezone", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ timezone: systemTz }),
    }).catch(() => {
      didSyncRef.current = false;
    });
  }, [isLoaded, user?.id, user?.publicMetadata?.timezone]);
}
